module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "copy"
    }
  }, [_vm._v("Also by Peter Baxter:"), _c('br'), _vm._v(" "), _c('i', [_vm._v("Rhodesia: Last Outpost of the British Empire"), _c('br'), _vm._v("\nFrance in Centrafrique: From Bokassa and Operation Barracuda to the days of the EUFOR"), _c('br'), _vm._v("\nSelous Scouts: Rhodesian Counter-Insurgency Specialists"), _c('br'), _vm._v("\nSAAF’s Border War: The South African Air Force in Combat, 1966–1989")])])]), _c('a', {
    attrs: {
      "id": "copy"
    }
  }, [_c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Co-published in 2012 by:")])]), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "copy"
    }
  }, [_vm._v("Helion & Company Limited"), _c('br'), _vm._v("\n26 Willow Road"), _c('br'), _vm._v("\nSolihull"), _c('br'), _vm._v("\nWest Midlands"), _c('br'), _vm._v("\nB91 1UE"), _c('br'), _vm._v("\nEngland"), _c('br'), _vm._v("\nTel. 0121 705 3393"), _c('br'), _vm._v("\nFax 0121 711 4075"), _c('br'), _vm._v("\nemail: ")]), _c('a', {
    attrs: {
      "href": "mailto:info@helion.co.uk"
    }
  }, [_vm._v("info@helion.co.uk")]), _c('br'), _vm._v("\nwebsite: "), _c('a', {
    attrs: {
      "href": "http://www.helion.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.helion.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("and")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("30° South Publishers (Pty) Ltd."), _c('br'), _vm._v("\n16 Ivy Road"), _c('br'), _vm._v("\nPinetown 3610"), _c('br'), _vm._v("\nSouth Africa"), _c('br'), _vm._v("\nemail: "), _c('a', {
    attrs: {
      "href": "mailto:info@30degreessouth.co.za"
    }
  }, [_vm._v("info@30degreessouth.co.za")]), _c('br'), _vm._v("\nwebsite: "), _c('a', {
    attrs: {
      "href": "http://www.30degreessouth.co.za",
      "target": "_blank"
    }
  }, [_vm._v("www.30degreessouth.co.za")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Text © Peter Baxter, 2012"), _c('br'), _vm._v("\nPhotographs © as individually credited")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Designed & typeset by Kerrin Cocks"), _c('br'), _vm._v("\nCover design by Kerrin Cocks"), _c('br'), _vm._v("\nPrinted in the UK by Henry Ling Limited, Dorchester, Dorset"), _c('br'), _vm._v("\nand in South Africa by Pinetown Printers (Pty) Ltd, Pinetown, KwaZulu-Natal")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("ISBN 978-1-920143-70-1 (South Africa)"), _c('br'), _vm._v("\nISBN 978-1-908916-22-8 (UK)"), _c('br'), _vm._v("\nEPUB ISBN: 9781909384354")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("British Library Cataloguing-in-Publication Data"), _c('br'), _vm._v("\nA catalogue record for this book is available from the British Library")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored, manipulated in any retrieval system, or transmitted in any mechanical, electronic form or by any other means, without the prior written authority of the publishers, except for short extracts in media reviews. Any person who engages in any unauthorized activity in relation to this publication shall be liable to criminal prosecution and claims for civil and criminal damages.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('i', [_vm._v("Cover photo")]), _vm._v(": A British soldier captures a suspected Mau Mau insurgent.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('i', [_vm._v("Publisher’s note")]), _c('br'), _vm._v("\nThe publishers would like to apologise for the absence of the 8-page colour-plate section that ordinarily appears in the Africa@War series titles. The sourcing of colour photos has proved problematic in that, a) there is a severe paucity of colour photos from the Mau Mau era, and b) some owners have made the contribution of photographic material subject to their own personal political views.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 57
// module chunks = 0